import { Routes, Route } from "react-router-dom";
import React, { useEffect, Suspense, useState } from "react";
import { toast } from "react-toastify";
import DYNAMIC_ROUTES from "../constant/dynamicRoutes";
import NotFound from "../components/NotFound";
import { useSelector, useDispatch } from "react-redux"
import action from "../redux/action";
import { _IMAPI } from "../assets/js/imapi";
import { CONFIG } from "../Config";
import COMMON_ROUTES from "../constant/commonRoutes"
import Loader from "../components/Loader";
import RDrawer from "../components/SideBar/sideBar"
import { getProfileMenu } from "../services/Report";


const AuthenticationRoute = () => {

    const profileData = useSelector(state => state.profileData);
    const dynamicMenus = useSelector(state => state.dynamicMenus);
    const [prodGrouID, setProdGroupID] = useState("");
    const dispatch = useDispatch();

    useEffect(() => {
        fetchProfileMenu()
    }, [])

    const fetchProfileMenu = () => {

        let params = {
            app_id: CONFIG.APP_ID
        }

        getProfileMenu(params).then((res) => {
            let menuData = res.data?.data ? res.data?.data : [];
            let prodGroupId = res.data.product_group_id;

            setProdGroupID(prodGroupId);

            let formattedMenus = menuData.filter((eachMenu) => eachMenu.prod_code !== "NA").map((eachMenu) => {
                let route = DYNAMIC_ROUTES.find((eachroute) => eachroute.prod_code === eachMenu.prod_code);
                return { ...eachMenu, path: route ? route.path : "" }
            });
           
            dispatch(action.dynamicMenus(formattedMenus))
        }).catch((err) => {
            toast.error(err)
        })
    }

    let dynamicRoutes = DYNAMIC_ROUTES.reduce((route, currRoute) => {
        let prod = dynamicMenus?.find((eachMenu) => eachMenu.prod_code === currRoute.prod_code);
        if (prod) {
            route.push({ ...currRoute, "users": prod.user_role });
        }
        return route
    }, [])

    let filteredCommonRoutes = COMMON_ROUTES;
    if (Number(prodGrouID) === 12) {
        filteredCommonRoutes = COMMON_ROUTES.filter((eachRoute) => eachRoute.title !== "Balance Transfer" && eachRoute.title !== "Request Fund")
    }
    let accessibleRoutes = dynamicRoutes.concat(filteredCommonRoutes, CONFIG.ROUTES);
    let filteredRoutes = profileData.guid === "global" ? accessibleRoutes.filter((route) => route.title !== "Admin") : accessibleRoutes;


    return (


        <RDrawer prodGrouID={prodGrouID} >
            <Suspense fallback={<Loader open={true} />}>
                <Routes>

                    {
                        filteredRoutes.length > 0 && filteredRoutes.map((item, index) => {

                            if (item.prod_code) {
                                return <Route exact key={index} path={item.path} element={item.element} />
                            }
                            if (!item.prod_code && item.users?.includes(profileData.role_name)) {
                                return <Route exact key={index} path={item.path} element={item.element} />
                            }

                        })
                    }
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </Suspense>
        </RDrawer>



    )
}

export default React.memo(AuthenticationRoute);